import * as React from 'react';

import FileDefault16 from './FileDefault16';

export const fileDefault16 = () => <FileDefault16 />;

export default {
    title: 'Icon|Fill|FileDefault16',
    component: FileDefault16,
    parameters: {
        notes: "`import FileDefault16 from 'box-ui-elements/es/icon/fill/FileDefault16';`",
    },
};
